import moment from 'moment';

export class AgendaGridUtils {
  /**
   * Interval pour laquel les lignes sont affiché
   * 1 = 1 par heure
   */
  static readonly lineInterval: number = 2;

  /**
   * Transformer une date en pourcentage vertical du haut de la grid
   * A binder avec style.top.%
   * @param date date/heure pour le calcul de l'emplacement
   */
  public static dateToVerticalPercent(date: Date) {
    const mDate = moment(date);
    const hours = mDate.hours();
    const minutes = hours * 60 + mDate.minutes();
    return AgendaGridUtils.minutesToVerticalPercent(minutes);
  }

  /**
   * Transformer des minutes en pourcentage vertical de la grid
   * @param minutes nombre de minutes a transformer en pourcentage de la grid
   */
  public static minutesToVerticalPercent(minutes: number): number {
    return (100 * minutes) / (24 * 60 + 60 / this.lineInterval);
  }
}
